import React from "react";

export const FirstPage = () => {
    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background:
                    "radial-gradient(1200px 600px at 50% 30%, rgba(56,132,246,0.12), transparent 60%), #000",
                color: "rgba(255,255,255,0.92)",
                textAlign: "center",
                padding: "24px",
            }}
        >
            <div>
                <h1
                    style={{
                        fontSize: "clamp(24px, 4vw, 42px)",
                        fontWeight: 900,
                        marginBottom: "12px",
                        letterSpacing: "0.3px",
                    }}
                >
                    Сторінка в процесі будівництва...
                </h1>

                <p
                    style={{
                        fontSize: "clamp(14px, 2vw, 18px)",
                        color: "rgba(255,255,255,0.65)",
                        margin: 0,
                    }}
                >
                    Поверніться пізніше.
                </p>
            </div>
        </div>
    );
};
